// @ts-check
import React from 'react';

import Button from '@liquidweb-dev/undercurrent/Button';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import { useLogout } from 'modules/oidc/useLogout';
import CartButton from '../../common/CartButton';
import TopNavSearch from '../../common/SearchButton';
import TopNavCreate from '../Create';
import TopNavTitle from '../Title';

/**
 * @param {object} props
 * @param {import('@liquidweb-dev/undercurrent/Button').ButtonProps} [props.logoutButtonProps]
 */
const BasketAdmin = ({ logoutButtonProps }) => {
	const logout = useLogout();

	return (
		<>
			<TopNavTitle flex="0% 1 1" overflow="auto" />
			<Stack
				direction="row"
				useFlexGap
				sx={{
					alignItems: 'center',
					gap: 150,
				}}
			>
				<TopNavCreate />
				<CartButton />
				<TopNavSearch />
				<Button
					variant="link"
					onClick={logout}
					size="large"
					{...logoutButtonProps}
				>
					Logout
				</Button>
			</Stack>
		</>
	);
};

export default BasketAdmin;
